import { render, staticRenderFns } from "./captains_registration_requests_status.vue?vue&type=template&id=0af22622&scoped=true&"
import script from "./captains_registration_requests_status.vue?vue&type=script&lang=js&"
export * from "./captains_registration_requests_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af22622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af22622')) {
      api.createRecord('0af22622', component.options)
    } else {
      api.reload('0af22622', component.options)
    }
    module.hot.accept("./captains_registration_requests_status.vue?vue&type=template&id=0af22622&scoped=true&", function () {
      api.rerender('0af22622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/captains_registration_requests_status.vue"
export default component.exports